import { render, staticRenderFns } from "./preprime-contact-popup.vue?vue&type=template&id=98ed8136"
import script from "./preprime-contact-popup.vue?vue&type=script&lang=js"
export * from "./preprime-contact-popup.vue?vue&type=script&lang=js"
import style0 from "./preprime-contact-popup.vue?vue&type=style&index=0&id=98ed8136&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports